export function luhnOk(num) {
  let s = 0, alt = false;
  for (let i = num.length - 1; i >= 0; i--) {
    let d = parseInt(num[i], 10);
    if (alt) { d *= 2; if (d > 9) d -= 9; }
    s += d; alt = !alt;
  }
  return s % 10 === 0;
}

// Returns a field-level error string (or "" when valid). Mirrors backend validation.
export function payoutMethodError(method, account, routing) {
  const a = (account || "").trim();
  if (!a) return "This field is required.";
  if (method === "debit_card") {
    const d = a.replace(/\D/g, "");
    if (d.length < 13 || d.length > 19 || !luhnOk(d)) return "Enter a valid debit card number.";
  } else if (method === "zelle") {
    const phone = a.replace(/[^\d+]/g, "");
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(a) && !/^\+?1?\d{10}$/.test(phone))
      return "Enter a valid Zelle email or US phone number.";
  } else if (method === "bank_account") {
    if (a.replace(/\D/g, "").length < 4) return "Enter a valid bank account number.";
    if ((routing || "").replace(/\D/g, "").length !== 9) return "A valid 9-digit routing number is required.";
  } else if (method === "paypal") {
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(a)) return "Enter a valid PayPal recipient email address.";
  }
  return "";
}
